export function isRedirectedFromReview () {
    return (localStorage.getItem("navto")!=='review')
}
export function showRecommendProducts() {
  return (
    localStorage.getItem("open_type") !== 'group' 
  );
}